// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-78478226","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/NudgeAnalytics.css
// module id = c3K8
// module chunks = 1